<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Overlay" });
import "tailwindcss/tailwind.css";
import { createEventDispatcher, onDestroy, onMount } from "svelte";
import { track } from "../../common/analytics.js";
import { closeModal } from "../../common/modal.js";
export let isOpen = false;
export let closeOnOutsideClick = true;
export let width = "50%";
export let height = "auto";
export let hash = "";
export let color = "white";
const TRACKING_NAME = hash.split("?")[0].replace("#", "");
const dispatch = createEventDispatcher();
let overlayHtmlElement = null;
const closeOverlay = () => {
    isOpen = false;
    closeModal();
    dispatch("close");
};
const onKeydown = (event) => {
    if (event.key === "Escape") {
        closeOverlay();
    }
};
const onOutsideModalClick = (event) => {
    if (overlayHtmlElement === null) {
        return;
    }
    if (event.target === null) {
        return;
    }
    if (!closeOnOutsideClick) {
        return;
    }
    if (overlayHtmlElement.contains(event.target)) {
        return;
    }
    closeOverlay();
};
onMount(() => {
    window.addEventListener("keydown", onKeydown);
    document.addEventListener("click", onOutsideModalClick, true);
    if (overlayHtmlElement !== null) {
        track("trackContentImpressionsWithinNode", overlayHtmlElement);
    }
});
onDestroy(() => {
    window.removeEventListener("keydown", onKeydown);
    document.removeEventListener("click", onOutsideModalClick, true);
});
</script>

{#if isOpen}
    <!-- data-content is named "Modal" for data consistency -->
    <div
        bind:this = { overlayHtmlElement }
        data-track-content
        data-content-name = { TRACKING_NAME ? `Modal: ${ TRACKING_NAME }` : 'Modal' }
        data-content-piece = 'Modal'
        class = { `s8-overlay s8-${ color }` }
        style = '--modal-width: { width }; --modal-height: { height }'
    >
        <div class = 's8-overlay-body'>
            <slot>
                Hello World
            </slot>
        </div>
    </div>
    <div class = 's8-overlay-background'></div>
{/if}

<style>

    div.s8-overlay {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        border-radius: 20px;
        z-index: 40;
        max-width: calc(100% - 40px);
        max-height: calc(100% - 40px);
        background-color: rgba(255, 255, 255, 1.00);
        width: var(--modal-width);
        height: var(--modal-height);
    }

        div.s8-overlay.s8-grey {
            background-color: rgb(248, 248, 248);
        }

        div.s8-overlay div.s8-overlay-body {
            --adjusted-height: calc(var(--modal-height) - 80px);

            max-height: var(--adjusted-height, calc(100vh - 80px));
            height: var(--adjusted-height);
            margin: 40px;
            margin-bottom: 0px;
            padding-bottom: 40px;
            overflow-y: auto;
        }

        div.s8-overlay:focus {
        outline: 2px solid transparent;
        outline-offset: 2px;
}

        div.s8-overlay :global(svg.s8-close-icon) {
            cursor: pointer;
            width: 20px;
            height: 20px;
            position: absolute;
            right: 20px;
            top: 20px;
        }

    div.s8-overlay-background {
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background: rgba(31,71,48,0.48);
        z-index: 39;
    }</style>